import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../Provider';
import {
    AGButton, CommerceLandingPageContainer,
    Div, FeatureContainer, FeaturesComponent,
    FeaturesDes, FeaturesTitle, GetStartedComponent, H1, HIWComponent,
    HIWContent, HIWContentTitile, HIWImg, ImageContainer, MidContainer,
    MidContent, MidContentTitle, SubHeader, TitleCustomMid,
    TitleCustomTop, TopContent
} from './commerceLandingPage.styled';
import { useUserMappingNotHaveRoles } from '../../hook/useUserMappingRoles';

const CommerceLandingPage = () => {
    const user = useContext(UserContext);
    const navigate = useNavigate();
    const [showData, setShowData] = useState<boolean>();
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const isMobileScreenPage = screenWidth < 769;
    const [handleMappingNoHaveRoles] = useUserMappingNotHaveRoles();

    const BASE_CSS = {
        TEXT_BASE: "!text-[#58585B] desktop:!text-[1.25rem] laptop:!text-[1.25rem] tablet:!text-[1.25rem] mobile:!text-[1.25rem]",
        TEXT_BASE_TITLE: "desktop:!text-[1.25rem] laptop:!text-[1.25rem] tablet:!text-[1.25rem] mobile:!text-[1.25rem]",
        TEXT_FEATURE: "mobile:mx-auto mobile:max-w-[100%] mobile:!text-start laptop:max-w-[100%] tablet:mx-auto tablet:max-w-[100%] tablet:!text-start",
        TEXT_FEATURE_TITLE: "mobile:!text-[1.375rem] tablet:text-[1.375rem] desktop:text-[1.375rem]",
        TEXT_TITLE: "desktop:!text-[2.3125rem] laptop:!text-[1.75rem] tablet:!text-[1.5rem] mobile:!text-[1.5rem]",
        TEXT_SEC_5: "laptop:!text-[2.5rem] tablet:!text-[1.625rem] mobile:!text-[1.625rem]"
    }

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        document.body.style.backgroundColor = "#f8f8f8"
        setShowData(true);
        return () => {
            document.body.style.backgroundColor = "rgb(228, 228, 228)"
        }
    }, [])
    if (!showData) { return null; }
    return (
        <CommerceLandingPageContainer isMobileScreen={isMobileScreenPage}>
            <TopContent className="flex flex-col sm:flex-row mid-content">
                <Div className="basis-1/1 sm:basis-full top-content" >
                    <TitleCustomTop className='title-top leading-none'>Get started today with</TitleCustomTop>
                    <TitleCustomMid className='title-mid'>Driving Commerce Marketplace</TitleCustomMid>
                    <Div className='mid-mobile'>
                        <TitleCustomMid className='title-mid-mobile'>Driving Commnerce</TitleCustomMid>
                        <TitleCustomMid className='title-mid-mobile'>Marketplace</TitleCustomMid>
                    </Div>
                    <SubHeader className={`sub-header ${BASE_CSS.TEXT_BASE}`}>Your gateway to specialized expertise, seamless collaboration, and new business opportunities
                    </SubHeader>
                    <div className="flex space-x-[15px]">
                        <AGButton className='!w-[200px]' onClick={() => { navigate(`/commerceProfile/${user?.individual.fkOrgId}?tab=home`) }}>Go to My Firm</AGButton>
                        {
                            handleMappingNoHaveRoles(
                                ["VendorUser"],
                                true,
                            ) ?
                                <AGButton className='!bg-[#e12626] hover:!opacity-[90%]' onClick={() => { navigate("/search-services") }}>Search</AGButton>
                                : null
                        }
                    </div>
                </Div>
            </TopContent>
            <MidContainer className='mid-container'>
                <MidContent >
                    <Div className="flex mobile:flex-col tablet:flex-col 769:!flex-row mobile:items-center laptop:items-center mid-content tablet:items-center">
                        <ImageContainer className="basis-full md:basis-1/2 sm:basis-1/1 tablet:w-[500px] tablet:h-auto mobile:w-[300px] mobile:h-auto ">
                            <img src="\AG_LandingPage\bulb.jpeg" alt="" />
                        </ImageContainer>
                        <MidContentTitle className="basis-full md:basis-1/2 sm:basis-1/1 tablet:mt-[10px] mobile::mt-[10px]">
                            <div style={{ display: 'flex', justifyContent: 'start', textAlign: 'justify' }}>
                                <H1 className={`${BASE_CSS.TEXT_SEC_5}`}>
                                    <span >The Power of</span>
                                    <span className='font-medium text-[#d13c32] pl-[5px]'>Collaboration</span>
                                </H1>
                            </div>
                            <p className={`${BASE_CSS.TEXT_BASE} text-left text-[1.125rem]`}>At Allinial Global, we believe growth happens when we work smarter, not harder. The Driving Commerce Marketplace is your central hub for unlocking new opportunities—connecting you with the right firms, specialized expertise, and strategic partners to help you expand services, streamline operations, and enhance client offerings. <br></br> More expertise. More connections. More wins.
                            </p>
                        </MidContentTitle>
                    </Div>
                </MidContent>
            </MidContainer>
            <FeatureContainer >
                <Div className="flex flex-col sm:flex-row Feature-content">
                    <Div style={{ display: 'block', textAlign: 'center' }}>
                        <H1 className={`feature-tile-mid ${BASE_CSS.TEXT_TITLE}`} >
                            <span className='text-[#333333]' >How It </span>
                            <span className='font-medium text-[#2c76aa]'>Works</span>
                        </H1>
                        <Div className='feature-tile-mid-mobile'>
                            <H1 className='feature-tile-mid-mobile text-[#2c76aa]'>How It</H1>
                            <H1 className='feature-tile-mid-mobile text-[#2c76aa]'>Works</H1>
                        </Div>
                    </Div>
                    <Div className="flex mobile:flex-col laptop:flex-row feature-items">
                        <FeaturesComponent className="basis-full md:basis-2/3 sm:basis-1/1 lg:basis-1/3">
                            <img src="\AG_LandingPage\highlightyourexpertise_sm.png" alt="" className='mx-auto' /><br></br>
                            <FeaturesTitle className={`feature-title ${BASE_CSS.TEXT_FEATURE_TITLE}`}>
                            Showcase Your Expertise
                            </FeaturesTitle>
                            <FeaturesDes className={`feature-des ${BASE_CSS.TEXT_BASE} ${BASE_CSS.TEXT_FEATURE}`} >Highlight your specialized services, industry niches, and unique capabilities with detailed descriptions, a competency rating scale, and direct contact information. Have proprietary solutions or products? Feature them for purchase. </FeaturesDes>
                        </FeaturesComponent>
                        <FeaturesComponent className="basis-full md:basis-2/3 sm:basis-1/1 lg:basis-1/3">
                            <img src="\AG_LandingPage\findtherightexpertise_sm.png" alt="" className='mx-auto' /><br></br>
                            <FeaturesTitle className={`feature-title ${BASE_CSS.TEXT_FEATURE_TITLE}`}>
                            Find the Right Expertise
                            </FeaturesTitle>
                            <FeaturesDes className={`feature-des ${BASE_CSS.TEXT_BASE} ${BASE_CSS.TEXT_FEATURE}`}>Need a specialized skill set for a client engagement? Identify firms with the exact expertise you’re looking for—instantly, seamlessly.</FeaturesDes>
                        </FeaturesComponent>
                        <FeaturesComponent className="basis-full md:basis-2/3 sm:basis-1/1 lg:basis-1/3">
                            <img src="\AG_LandingPage\expandyourserviceofferings_sm.png" alt="" className='mx-auto' /><br></br>
                            <FeaturesTitle className={`feature-title ${BASE_CSS.TEXT_FEATURE_TITLE}`}>
                            Expand Your Service Offerings
                            </FeaturesTitle>
                            <FeaturesDes className={`feature-des ${BASE_CSS.TEXT_BASE} ${BASE_CSS.TEXT_FEATURE}`}>Want to strengthen or diversify your firm’s capabilities? Use the Driving Commerce Marketplace to find firms with complementary services and discover new ways to drive growth.</FeaturesDes>
                        </FeaturesComponent>
                    </Div>
                </Div>
            </FeatureContainer>
            <MidContainer className='mid-container'>
                <MidContent >
                <Div className="flex mobile:flex-col tablet:flex-col 769:!flex-row mobile:items-center laptop:items-center mid-content tablet:items-center">
                        <MidContentTitle className="basis-full md:basis-1/2 sm:basis-1/1 tablet:mt-[10px] mobile::mt-[10px]">
                            <div style={{ display: 'flex', justifyContent: 'start', textAlign: 'justify' }}>
                                <H1 className={`${BASE_CSS.TEXT_SEC_5}`}>
                                    <span >Connect with Strategic Partners &</span>
                                    <span className='font-medium text-[#d13c32] pl-[5px]'>Unlock Exclusive Solutions</span>
                                </H1>
                            </div>
                            <p className={`${BASE_CSS.TEXT_BASE} text-left text-[1.125rem]`}>The marketplace is more than an interactive platform to showcase or browse for expertise. It’s also a powerful gateway to connect with strategic partnerships and member-exclusive solutions that drive real growth. 
                            </p>
                            <ul>
                                <li><Div className='Showcase-item'>
                                        <p className={`${BASE_CSS.TEXT_BASE}`}>Discover who our partners are, what they do, and the areas they support.</p>
                                    </Div>
                                </li>
                                <li><Div className='Showcase-item'>
                                        <p className={`${BASE_CSS.TEXT_BASE}`}>Explore the exclusive benefits they offer to Allinial Global members.</p>
                                    </Div>
                                </li>
                                <li><Div className='Showcase-item'>
                                        <p className={`${BASE_CSS.TEXT_BASE}`}>Access cutting-edge products and solutions designed to enhance 
                                        your client offerings.</p>
                                    </Div>
                                </li>
                            </ul>
                        </MidContentTitle>
                        <ImageContainer className="basis-full md:basis-1/2 sm:basis-1/1 tablet:w-[500px] tablet:h-auto mobile:w-[300px] mobile:h-auto ">
                            <img src="\AG_LandingPage\laptop.jpeg" alt="" />
                        </ImageContainer>
                    </Div>
                </MidContent>
            </MidContainer>
            <MidContainer className='feature-content'>
                <MidContent >
                    <Div className="flex mobile:flex-col tablet:flex-col 769:!flex-row mobile:items-center laptop:items-center mid-content tablet:items-center">
                    <ImageContainer className="basis-full md:basis-1/3 sm:basis-1/1 tablet:w-[680px] tablet:h-auto mobile:w-[300px] mobile:h-auto ">
                            <img src="\AG_LandingPage\bulb.jpeg" alt="" />
                        </ImageContainer>
                        <MidContentTitle className="basis-full md:basis-2/3 sm:basis-1/1 tablet:mt-[10px] mobile::mt-[10px]">
                            <div style={{ display: 'flex', justifyContent: 'start', textAlign: 'justify' }}>
                                <H1 className={`${BASE_CSS.TEXT_SEC_5}`}>
                                    <span >The Power of</span>
                                    <span className='font-medium text-[#d13c32] pl-[5px]'>Collaboration</span>
                                </H1>
                            </div>
                            <p className={`${BASE_CSS.TEXT_BASE} text-left text-[1.125rem]`}>At Allinial Global, we believe growth happens when we work smarter, not harder. The Driving Commerce Marketplace is your central hub for unlocking new opportunities—connecting you with the right firms, specialized expertise, and strategic partners to help you expand services, streamline operations, and enhance client offerings. <br></br> More expertise. More connections. More wins.
                            </p>
                        </MidContentTitle>
                    </Div>
                </MidContent>
            </MidContainer>
            <HIWComponent>
                <HIWContent>
                    <Div className="flex mobile2:flex-col  tablet2:flex-row HIW-content tablet:items-center tablet2:justify-center 769:space-x-[50px] laptop:space-x-[100px]">
                        <HIWImg className="sm:flex-row hiw-img-content flex-auto tablet2:w-[345px]">
                            <img id='hiw-lg' src="\AG_LandingPage\Frame 1000005261.svg" alt="" className='w-[345px] h-[451px] max-w-none' />
                            <img id='hiw-sm' src="\AG_LandingPage\Frame 1000005261-mobile.svg" alt="" />
                        </HIWImg>
                        <HIWContentTitile className=" sm:flex-row flex-auto">
                            <h1 id='hiw-title' className={`${BASE_CSS.TEXT_SEC_5}`}>How It Works:</h1>
                            <h1 id='hiw-title-des' className={`${BASE_CSS.TEXT_SEC_5}`}>Simplify Your Path to Collaboration</h1>
                            <ul>
                                <li>
                                    <Div className='Showcase-item'>
                                        <h2 className={`${BASE_CSS.TEXT_BASE_TITLE}`}>1. Showcase Your Expertise:</h2>
                                        <p className={`${BASE_CSS.TEXT_BASE}`}>Start by completing your Commerce Service Profile. Highlight your organization's specialized services, expertise levels, and key contacts to stand out in the marketplace.</p>
                                    </Div>
                                </li>
                                <li>
                                    <Div className='Showcase-item'>
                                        <h2 className={`${BASE_CSS.TEXT_BASE_TITLE}`}>2. Discover and Connect:</h2>
                                        <p className={`${BASE_CSS.TEXT_BASE}`}>Browse the marketplace to find peer organizations with complementary skills or
                                            services. Use our intuitive platform to search, view, and engage with potential partners.</p>
                                    </Div>
                                </li>
                                <li>
                                    <Div className='Showcase-item'>
                                        <h2 className={`${BASE_CSS.TEXT_BASE_TITLE}`}>3. Collaborate and Grow:</h2>
                                        <p className={`${BASE_CSS.TEXT_BASE}`}>Leverage the strength of the Driving Commerce community to enhance your
                                            service offerings, gain new insights, and drive your organization's growth.</p>
                                    </Div>
                                </li>
                            </ul>
                        </HIWContentTitile>
                    </Div>
                </HIWContent>
            </HIWComponent>
            <Div className='get-started-container'>
                <GetStartedComponent>
                    <h1 id='get-started-title-top' className={`${BASE_CSS.TEXT_SEC_5}`}>Ready to Amplify</h1>
                    <h1 id='get-started-title-bottom' className={`${BASE_CSS.TEXT_SEC_5} font-bold`}>Your Organization's Potential?</h1>
                    <div className="flex space-x-[15px]">
                        <AGButton className='!w-[200px]' onClick={() => { navigate(`/commerceProfile/${user?.individual.fkOrgId}?tab=home`) }}>Go to My Organization</AGButton>
                        {
                            handleMappingNoHaveRoles(
                                ["VendorUser"],
                                true,
                            ) ?
                                <AGButton className='!bg-[#e12626] hover:!opacity-[90%]' onClick={() => { navigate("/search-services") }}>Search</AGButton>
                                : null
                        }
                    </div>
                </GetStartedComponent>
            </Div>
        </CommerceLandingPageContainer>
    )
}
export default CommerceLandingPage;
